export default "__VITE_ASSET__ded2c8bf__"